import { learningLessons, completedExerciseIndices, } from "./learningCurriculum.js";
export function learningStartingPoint(value) {
    return value === "new" || value === "rules" || value === "regular"
        ? value
        : undefined;
}
/** Difficulty guides recommendations; it never locks the library or awards skipped lessons. */
export function recommendedLearningLesson({ progress, startingPoint, establishedPlayer = false, hasOpeningProgress = false, topic, }) {
    const indices = (lesson) => {
        var _a;
        return completedExerciseIndices((_a = progress.find((row) => row.slug === lesson.slug)) === null || _a === void 0 ? void 0 : _a.completedExercises, lesson.exercises.length);
    };
    const completed = (lesson) => indices(lesson).length >= lesson.exercises.length;
    const knowsRules = startingPoint
        ? startingPoint !== "new"
        : establishedPlayer ||
            hasOpeningProgress ||
            learningLessons.some((lesson) => lesson.group !== "basics" && indices(lesson).length > 0);
    const available = learningLessons.filter((lesson) => !completed(lesson) && (!knowsRules || lesson.group !== "basics"));
    // Preserve a started course, unless the player explicitly chose to skip the rules.
    const resume = learningLessons.find((lesson) => !completed(lesson) &&
        indices(lesson).length > 0 &&
        !(startingPoint && startingPoint !== "new" && lesson.group === "basics"));
    if (resume)
        return resume;
    const prerequisite = (lesson, seen = new Set()) => {
        if (seen.has(lesson.slug))
            return lesson;
        seen.add(lesson.slug);
        for (const slug of lesson.prerequisites) {
            const earlier = learningLessons.find((item) => item.slug === slug);
            if (earlier &&
                !completed(earlier) &&
                !(knowsRules && earlier.group === "basics"))
                return prerequisite(earlier, seen);
        }
        return lesson;
    };
    // Finish the rules before introducing concepts from a reviewed game.
    if (!knowsRules) {
        const basics = available.find((lesson) => lesson.group === "basics");
        if (basics)
            return prerequisite(basics);
    }
    if (topic && !completed(topic))
        return prerequisite(topic);
    const target = startingPoint === "regular"
        ? available.find((lesson) => lesson.difficulty === "intermediate") ||
            available[0]
        : available[0];
    return target && prerequisite(target);
}
export const openingLessonMetadata = Object.fromEntries([
    "caro-kann-defense",
    "danish-gambit",
    "english-opening",
    "french-defense",
    "fried-liver-attack",
    "italian-game",
    "kings-indian-defense",
    "london-system",
    "queens-gambit-declined",
    "queens-gambit",
    "ruy-lopez",
    "scandinavian-defense",
    "scotch-game",
    "sicilian-defense",
    "slav-defense",
].map((slug) => [
    slug,
    {
        difficulty: [
            "english-opening",
            "kings-indian-defense",
            "sicilian-defense",
            "ruy-lopez",
        ].includes(slug)
            ? "intermediate"
            : "beginner",
        prerequisites: ["development"],
        skill: "openings",
    },
]));
//# sourceMappingURL=learningRecommendations.js.map